import axios from 'axios';
import { FETCH_SESSION_FAILURE } from '../actions/session';
import { FLAG_CACHE_KEY, getReactEnv } from '../constants';
import {
  currentEphemeralEnv,
  ephemeralOriginFor,
} from '../constants/ephemeral';
import { clearCache } from './storage';

export const checkResponseToBeArray = (response) => {
  if (!Array.isArray(response.data)) {
    throw new TypeError(`response was ${typeof response.data}, expected array`);
  }
};

const setupAxios = (store) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
  axios.defaults.headers.common['Content-Type'] = 'application/json';

  if (getReactEnv() === 'development') {
    // Ephemeral ("mini-me") environments land here, because their per-environment
    // hostnames are not in hostnameToEnv. Derive the API host from the CURRENT one so
    // wallet-<hash> talks to wallet-api-<hash> -- its OWN environment.
    //
    // The previous hardcoded 'https://wallet-api.idme.test/api' was the single worst
    // bug in the per-tester story: that flat name is routed by the shared terminator
    // to one designated primary namespace, so every wallet API call from every
    // environment was served by the same one. No error, wrong data.
    const ee = currentEphemeralEnv();

    if (ee) {
      const origin = ephemeralOriginFor('wallet-api', ee);
      axios.defaults.baseURL = `${origin}/api`;
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = origin;
    } else if (window.location.href.includes('idme.test:8081')) {
      // check if current url contains idme.test:8081
      axios.defaults.baseURL = 'http://wallet-api.idme.test:8081/api';
      axios.defaults.headers.common['Access-Control-Allow-Origin'] =
        'http://wallet-api.idme.test:8081';
    } else {
      axios.defaults.baseURL = 'https://wallet-api.idme.test/api';
      axios.defaults.headers.common['Access-Control-Allow-Origin'] =
        'https://wallet-api.idme.test';
    }
  } else {
    axios.defaults.baseURL = '/api';
  }

  axios.interceptors.request.use((config) => {
    const { csrfToken } = store.getState().session;

    if (!csrfToken) {
      return config;
    }

    config.headers['X-CSRF-TOKEN'] = csrfToken;
    return config;
  });

  axios.interceptors.response.use(undefined, (error) => {
    if (error.response && error.response.status === 401) {
      clearCache(FLAG_CACHE_KEY);
      if (!error.config?.handlesUnauthorized) {
        store.dispatch({
          type: FETCH_SESSION_FAILURE,
        });
      }
    }

    return Promise.reject(error);
  });
};

export default setupAxios;
